import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DiffItem, GoalDiffAction } from '../../coaching-base/diff-decorator';
import { DiffAction } from '../../coaching-base/diff-decorator/diff-action.model';
import { NoteDiffContext } from '../../coaching-base/diff-decorator/note-diff-context.model';
import { EntityType } from '../../coaching-base/general';
import { TranslationKeyMap } from '../coaching-commitment.i18n';
import { GoalDiffContextView } from '../commitment/goal-diff-context-view.model';

const noteDiffActionMap: { [key: number]: string } = {
    [DiffAction.CREATE]: TranslationKeyMap._9767_ADDED,
    [DiffAction.UPDATE]: TranslationKeyMap._9766_UPDATED_TO,
    [DiffAction.DELETE]: TranslationKeyMap._9496_DELETED,
};

const observationDiffActionMap: { [key: number]: string } = {
    [DiffAction.CREATE]: TranslationKeyMap._9763_LINKED,
    [DiffAction.UPDATE]: TranslationKeyMap._842_N_A,
    [DiffAction.DELETE]: TranslationKeyMap._9764_UNLINKED,
};

const goalDiffActionMap: { [key: number]: string } = {
    [GoalDiffAction.SET_VALUE]: TranslationKeyMap._9797_SET_THE_GOAL,
    [GoalDiffAction.UPDATE_VALUE]: TranslationKeyMap._742_GOAL_UPDATED,
    [GoalDiffAction.UPDATE_EXPECTED_ACHIEVEMENT_DATE]:
        TranslationKeyMap._9798_EXPECTED_ACHIEVEMENT_DATE_UPDATED,
    [GoalDiffAction.CLOSE]: TranslationKeyMap._9799_GOAL_CLOSE_REQUEST,
};

@Pipe({
    name: 'cmpsDiffItemActionLabel',
})
export class CmpsDiffItemActionLabelPipe implements PipeTransform {
    constructor(private readonly _translateService: TranslateService) {}

    transform(value: DiffItem): string {
        switch (value.entityTypeId) {
            case EntityType.Note: {
                const ctx = value.context as NoteDiffContext;
                const a = this._translateService.instant(
                    noteDiffActionMap[value.action],
                );
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                return `<span>${a}</span>&nbsp;${
                    value.action === DiffAction.DELETE
                        ? ctx.contentBefore
                        : ctx.contentAfter
                }`;
            }
            case EntityType.CoachingEvent:
                return this._translateService.instant(
                    observationDiffActionMap[value.action],
                );
            case EntityType.Goal: {
                const ctx = value.context as GoalDiffContextView;
                return this._translateService.instant(
                    goalDiffActionMap[ctx.action],
                );
            }
        }
    }
}
